<template>
  <v-dialog
    :value="true"
    persistent
    @keydown.prevent.enter="submit"
    width="fit-content"
    content-class="cluster-closure-selection-dialog"
  >
    <v-card class="dialog-box">
      <v-card-title>{{ $t("ClusterMultipleClosures") }}</v-card-title>

      <v-card-text style="overflow: visible" class="scroll-fire-fox">
        <div>{{ $t("ClusterSelectClosure") }}...</div>
        <treeselect
          v-model="selectedClosure"
          :options="closureOptions"
          :normalizer="normalizer"
          style="width: 250px"
        />
      </v-card-text>

      <v-card-actions>
        <v-btn @click="close" :ripple="false" class="secondary-button" text>
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn @click="submit" :ripple="false" class="main-button" text>
          {{ $t("Submit") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ClusterClosureSelection",

  props: {
    closureOptions: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      selectedClosure: null
    };
  },

  methods: {
    submit() {
      this.$emit("submit", this.selectedClosure);
      this.close();
    },

    close() {
      this.$emit("close");
    },

    normalizer(node) {
      let label = node.cl_label ? node.cl_label : node.cl_id;
      return {
        id: node.cl_uuid,
        label: label
      };
    }
  }
};
</script>

<style>
.cluster-closure-selection-dialog.v-dialog {
  overflow: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/Cluster/ClosureSelection.vue